var custom = {
  init: function () {
    custom.sliderHome();
    custom.searchExpand();
    custom.sliderCategory();
    custom.countDown();
    custom.mapMarket();
    custom.sidebarStickitCustom();
    custom.quantityNum();
    custom.sliderGallery();
    custom.hourReserv();
    custom.socialTeacher();
    custom.icoWhats();
    custom.clickVideo();
    custom.sliderCreators();
    custom.videoIframe();
    custom.sliderWhatDo();
    custom.sliderCd();
    custom.changePlanTicket();
    custom.sliderPartners();
    custom.sliderAffiliate();
    custom.paymentMethods();
    custom.copyLink();
    custom.scrollUp();
    custom.lazyLoadVideo();
    custom.scrollFilter();
    custom.toggleFilter();
    custom.loadPartners();
    custom.sidebarStickitCustom();
    custom.titleStiky();
    custom.moreBlock();
    custom.moreBlockAll();
    custom.sliderFunc();
    custom.anclaSeccion();
    custom.ourClient();
  },
  token: "",
  _timeZone: "",
  sliderHome: function () {
    if ($(".slider-home").length) {
      $(".slider-home").slick({
        arrows: false,
        dots: true,
        infinite: true,
        autoplay: true,
        autoplaySpeed: 4000,
        fade: true,
        cssEase: "linear",
      });
      $(".slider-home").on(
        "beforeChange",
        function (event, slick, currentSlide, nextSlide) {
          $(".slider-info").removeClass("aos-init").removeClass("aos-animate");
        }
      );
      $(".slider-home").on(
        "afterChange",
        function (event, slick, currentSlide, nextSlide) {
          AOS.refresh();
        }
      );
    }
  },
  searchExpand: function () {
    function buttonUp() {
      var inputVal = $(".searchbox-input").val();
      inputVal = $.trim(inputVal).length;
      if (inputVal !== 0) {
        $(".searchbox-icon").css("display", "none");
      } else {
        $(".searchbox-input").val("");
        $(".searchbox-icon").css("display", "block");
      }
    }
    var submitIcon = $(".searchbox-icon");
    var inputBox = $(".searchbox-input");
    var searchBox = $(".searchbox");
    var isOpen = false;
    submitIcon.click(function () {
      if (isOpen == false) {
        searchBox.addClass("searchbox-open");
        inputBox.focus();
        isOpen = true;
      } else {
        searchBox.removeClass("searchbox-open");
        inputBox.focusout();
        isOpen = false;
      }
    });
    submitIcon.mouseup(function () {
      return false;
    });
    searchBox.mouseup(function () {
      return false;
    });
    $(document).mouseup(function () {
      if (isOpen == true) {
        $(".searchbox-icon").css("display", "block");
        submitIcon.click();
      }
    });
  },
  countDown: function () {
    if ($(".listTiempo").length) {
      $("[data-countdown]").each(function () {
        var $this = $(this);
        var finalDate = $(this).data("countdown");
        var timeZone = $(this).data("timezone");
        var newFinalDateTZ = finalDate;
        if (moment && timeZone) {
          console.log("timezone");
          var momentDate = moment.tz(finalDate, timeZone);
          newFinalDateTZ = momentDate.toDate();
        }

        $this.countdown(newFinalDateTZ, function (event) {
          $this = $(this).html(
            event.strftime(
              "" +
                '<div><span class="datos-tiempo">%D</span><em>Días</em></div><span>:</span>' +
                '<div><span class="datos-tiempo">%H</span><em>Horas</em></div><span>:</span>' +
                '<div><span class="datos-tiempo">%M</span><em>Min</em></div><span>:</span>' +
                '<div><span class="datos-tiempo">%S</span><em>Seg</em></div>'
            )
          );
        });
      });
    }
  },
  sliderCategory: function () {
    if ($(".slider-category").length) {
      $(".slider-category").slick({
        arrows: true,
        dots: false,
        infinite: true,
        autoplay: true,
        autoplaySpeed: 3000,
        infinite: true,
        slidesToShow: 6,
        slidesToScroll: 1,
        responsive: [
          {
            breakpoint: 1200,
            settings: {
              slidesToShow: 5,
              slidesToScroll: 1,
            },
          },
          {
            breakpoint: 992,
            settings: {
              slidesToShow: 4,
              slidesToScroll: 1,
            },
          },
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 1,
            },
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1,
            },
          },
        ],
      });
    }
  },
  mapMarket: function () {
    if ($(".map-canvas").length) {
      $(".mapShow").click(function (e) {
        e.preventDefault();
        $(".mapShow").remove();
        $(".map-canvas").addClass("map-show");
        var lat = $(".map-canvas").data("lat");
        var log = $(".map-canvas").data("lon");
        var direc = $(".map-canvas").data("direc");

        var map = new google.maps.Map($(".map-canvas")[0], {
          zoom: 16,
          center: new google.maps.LatLng(lat, log),
        });
        var marker = new google.maps.Marker({
          map: map,
          position: new google.maps.LatLng(lat, log),
        });
        var info = new SnazzyInfoWindow({
          marker: marker,
          closeOnMapClick: false,
          content: direc,
        });
        info.open();
      });
    }
  },
  sidebarStickitCustom: function () {
    if ($(".sidebar-stickit-custom").length) {
      $(".sidebar-stickit-custom").stickit({
        screenMinWidth: 992,
        top: 60,
      });
    }
  },
  toggleUserCourse: function (e) {
    if ($(".info-text-autor").hasClass("toggle-active")) {
      $(".toggle-click").removeClass("a-toggle");
      $(".info-text-autor").removeClass("toggle-active");
    } else {
      $(".toggle-click").addClass("a-toggle");
      $(".info-text-autor").addClass("toggle-active");
    }
  },
  quantityNum: function () {
    if ($(".quantity").length) {
      $(".add-l").click(function () {
        var dataMax = $(this).data("max");
        if ($(this).prev().val() < dataMax) {
          $(this)
            .prev()
            .val(+$(this).prev().val() + 1);
        }
      });
      $(".sub-l").click(function () {
        if ($(this).next().val() > 1) {
          if ($(this).next().val() > 1)
            $(this)
              .next()
              .val(+$(this).next().val() - 1);
        }
      });
    }
  },
  sliderGallery: function () {
    if ($(".inner-gallery-event").length) {
      $(".popup-gallery-lead").magnificPopup({
        delegate: "a",
        type: "image",
        tLoading: "Cargando imagen #%curr%...",
        mainClass: "mfp-img-mobile",
        gallery: {
          enabled: true,
          navigateByImgClick: true,
          preload: [0, 1], // Will preload 0 - before current, and 1 after the current image
        },
        image: {
          tError: "",
          titleSrc: function (item) {
            return item.el.attr("title");
          },
        },
      });
    }
  },
  hourReserv: function () {
    if ($(".block-calendar-reserv").length) {
      $("#datepickerMent").datepicker({
        language: "es",
        todayHighlight: true,
      });

      if ($(".footer-calendar-m").length) {
        $(".hour-select").customSelect();
      }
      $(".event-resv").click(function () {
        var eventR = $(this);
        eventR.hide();
        eventR.parent("li").find(".resv-btn").show();
      });
    }
  },
  socialTeacher: function () {
    $(".up-social").click(function () {
      if ($(this).parent(".downActive").length) {
        $(this).parent(".social-teacher").removeClass("downActive");
      } else {
        $(this).parent(".social-teacher").addClass("downActive");
      }
    });
  },
  icoWhats: function () {
    if ($("#block-whats").length) {
      var navigationContainer = $("#block-whats"),
        mainNavigation = navigationContainer.find(
          "#cd-main-whats .block-nav-m"
        );
      $(".cd-whats-trigger").on("click", function (e) {
        e.preventDefault();
        $(this).toggleClass("menu-is-open");
        mainNavigation
          .off(
            "webkitTransitionEnd otransitionend oTransitionEnd msTransitionEnd transitionend"
          )
          .toggleClass("is-visible");
      });
    }
  },
  clickVideo: function () {
    if ($(".video-m").length) {
      $(".video-m").click(function () {
        $(this).hide();
        $(this).siblings(".b-content-video").show();
        $(this).siblings(".b-content-video").addClass("video-concl");
      });
    }
    if ($(".video-iframe-t").length) {
      $(".video-iframe-t").click(function () {
        $(this).hide();
        $(this).siblings(".b-content-video").show();
        $(this).siblings(".b-content-video").addClass("video-concl");
      });
    }
    $("#reserveModal").on("hidden.bs.modal", function (event) {
      $("#block-reserv-c").show();
      $("#listHourCalendar").hide();
      $(".btn-return").hide();
    });
  },
  sliderCreators: function () {
    if ($(".slider-creators").length) {
      $(".slider-creators").slick({
        arrows: true,
        dots: true,
        infinite: true,
        autoplay: true,
        autoplaySpeed: 3000,
        slidesToShow: 4,
        slidesToScroll: 1,
        mobileFirst: true,
        responsive: [
          {
            breakpoint: 1200,
            settings: {
              slidesToShow: 4,
              slidesToScroll: 1,
            },
          },
          {
            breakpoint: 992,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 1,
            },
          },
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1,
            },
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
            },
          },
          {
            breakpoint: 320,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
            },
          },
        ],
      });
    }
  },
  sliderAffiliate: function () {
    if ($(".slider-affiliate").length) {
      $(".slider-affiliate").slick({
        arrows: true,
        dots: false,
        infinite: true,
        autoplay: true,
        autoplaySpeed: 3000,
        slidesToShow: 3,
        slidesToScroll: 1,
        mobileFirst: true,
        responsive: [
          {
            breakpoint: 1200,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 1,
            },
          },
          {
            breakpoint: 992,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 1,
            },
          },
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1,
            },
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
            },
          },
          {
            breakpoint: 320,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
            },
          },
        ],
      });
    }
  },
  sliderWhatDo: function () {
    if ($(".s-what-do").length) {
      $(".s-what-do").slick({
        arrows: true,
        dots: true,
        infinite: true,
        autoplay: true,
        autoplaySpeed: 3000,
        slidesToShow: 1,
        slidesToScroll: 1,
      });
    }
  },
  sliderCd: function () {
    if ($(".slider-cd").length) {
      $(".slider-cd").slick({
        arrows: true,
        dots: true,
        infinite: true,
        autoplaySpeed: 3000,
        slidesToShow: 1,
        slidesToScroll: 1,
        adaptiveHeight: true,
      });

      $("a[data-slide]").click(function (e) {
        e.preventDefault();
        $(".list-control-nav-s li a").removeClass("active");
        $(this).addClass("active");
        var slideno = $(this).data("slide");
        $(".slider-cd").slick("slickGoTo", slideno - 1);
      });

      $(".slider-cd").on(
        "beforeChange",
        function (event, slick, currentSlide, nextSlide) {
          $(".list-control-nav-s li a").removeClass("active");
          var countSlider = nextSlide + 1;
          $(".list-control-nav-s li").each(function (e) {
            var dataSlideLi = $(this).find("a").data("slide");
            if (dataSlideLi == countSlider) {
              $(this).find("a").addClass("active");
            }
          });
        }
      );
    }
  },
  videoIframe: function () {
    $(".item-video").click(function () {
      var htmlVideo = $(this).find(".hidden-video").html();
      var linkSrc = $(this).data("video");
      $("#videoModal").modal("show");
      $("#course-video-content").html(htmlVideo);
      setTimeout(function () {
        $("#course-video-content").find("iframe").attr("src", linkSrc);
      }, 200);
    });
    $("#videoModal").on("hidden.bs.modal", function (event) {
      $("#course-video-content").find("iframe").attr("src", "");
    });
  },
  changePlanTicket: function () {
    $("#changePlan").on("change", function () {
      //codigo
    });
  },
  sliderPartners: function () {
    if ($(".s-slider-partners").length) {
      $(".s-slider-partners").slick({
        infinite: false,
        arrows: true,
        dots: false,
        slidesToShow: 4,
        autoplay: true,
        autoplaySpeed: 3000,
        slidesToScroll: 1,
        responsive: [
          {
            breakpoint: 1200,
            settings: {
              slidesToShow: 4,
              slidesToScroll: 1,
            },
          },
          {
            breakpoint: 992,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 1,
            },
          },
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1,
            },
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1,
            },
          },
          {
            breakpoint: 320,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
            },
          },
        ],
      });
    }
  },
  paymentMethods: function () {
    if ($(".b-select-payment").length) {
      const selectValue = document.getElementById("select-country");

      const selectCountry = document.getElementById("select-country");
      const contentCard = document.getElementById("content-card");
      const contentLocal = document.getElementById("content-local");
      const contentWallet = document.getElementById("content-wallet");

      fetch(main.baseUrl + "mk-service/country")
        .then((res) => res.json())
        .then((data) => {
          let countrys = data;
          countrys.map(function (country) {
            if (country.code === "pe") {
              selectCountry.innerHTML += `<option value="${country.code}" selected>${country.name}</option>`;
            } else {
              selectCountry.innerHTML += `<option value="${country.code}">${country.name}</option>`;
            }
          });
          setTimeout(() => {
            $(".select-pay").customSelect({
              search: true,
            });

            valueSelected(selectValue.value);
          }, 200);
        });

      function valueSelected(dataValue) {
        servicePaymentMethod(dataValue);
      }

      function servicePaymentMethod(country) {
        fetch(main.baseUrl + "mk-service/payment-method/" + country)
          .then((res) => res.json())
          .then((data) => {
            let methodsCards = data.card;
            let methodsLocals = data.local;
            let methodsOthers = data.other;

            contentCard.innerHTML = "";
            contentLocal.innerHTML = "";
            contentWallet.innerHTML = "";

            methodsCards.map(function (methodsCard) {
              contentCard.innerHTML += `<li><img src="${
                main.staticUrl +
                "maqueta/checkout/img/method/" +
                methodsCard.nameImage
              }" alt="${methodsCard.name}"></li>`;
            });
            methodsLocals.map(function (methodsLocal) {
              contentLocal.innerHTML += `<li><img src="${
                main.staticUrl +
                "maqueta/checkout/img/method/" +
                methodsLocal.nameImage
              }" alt="${methodsLocal.name}"></li>`;
            });
            methodsOthers.map(function (methodsOther) {
              contentWallet.innerHTML += `<li><img src="${
                main.staticUrl +
                "maqueta/checkout/img/method/" +
                methodsOther.nameImage
              }" alt="${methodsOther.name}"></li>`;
            });
          });
      }

      $("#select-country").change(function () {
        var dealer = $(this).val();
        valueSelected(dealer);
      });
    }
  },
  copyLink: function () {
    $(".btn-copy").click(function (e) {
      e.preventDefault();

      var thisL = $(this);

      var linkB = thisL.parent().parent().find(".link-copy").html();
      console.log(linkB);
      var linkClean = linkB.trim();

      console.log(linkClean);

      navigator.clipboard
        .writeText(linkClean)
        .then(() => {
          thisL.append("<div class='tip' id='copied_tip'>Copiado!</div>");
          setTimeout(function () {
            $("#copied_tip").remove();
          }, 800);
        })
        .catch((err) => {
          console.log("Error al copiar", err);
        });
    });
  },
  scrollUp: function () {
    $(window).scroll(function () {
      if ($(this).scrollTop() > 100) $(".scrolltop").fadeIn();
      else $(".scrolltop").fadeOut();
    });
    $(".scrolltop").click(function (e) {
      e.preventDefault();
      $("html, body").animate({ scrollTop: 0 }, 600);
      return false;
    });
  },
  anclaSeccion: function () {
    $(".seccionAncla").click(function (e) {
      e.preventDefault();
      var strAncla = $(this).attr("href");
      $("body,html")
        .stop(true, true)
        .animate(
          {
            scrollTop: $(strAncla).offset().top,
          },
          1000
        );
    });
  },
  lazyLoadVideo: function () {
    if ($("video.lazy").length) {
      var lazyVideos = [].slice.call(document.querySelectorAll("video.lazy"));

      if ("IntersectionObserver" in window) {
        var lazyVideoObserver = new IntersectionObserver(function (
          entries,
          observer
        ) {
          entries.forEach(function (video) {
            if (video.isIntersecting) {
              for (var source in video.target.children) {
                var videoSource = video.target.children[source];
                if (
                  typeof videoSource.tagName === "string" &&
                  videoSource.tagName === "SOURCE"
                ) {
                  videoSource.src = videoSource.dataset.src;
                }
              }

              video.target.load();
              video.target.classList.remove("lazy");
              lazyVideoObserver.unobserve(video.target);
            }
          });
        });

        lazyVideos.forEach(function (lazyVideo) {
          lazyVideoObserver.observe(lazyVideo);
        });
      }
    }
  },
  scrollFilter: function () {
    if ($(".scrollbar-inner").length) {
      $(".scrollbar-inner").scrollbar();
    }
  },
  toggleFilter: function () {
    if ($(".inner-filter-result").length) {
      function myFunction(x) {
        if (x.matches) {
          $(".inner-filter-result").removeClass("active-filter");
        } else {
          $("body").removeClass("sidebar-movil-active");
        }
      }

      var x = window.matchMedia("(max-width: 992px)");
      myFunction(x);
      x.addListener(myFunction);

      function handler1() {
        $(".inner-filter-result").addClass("active-filter");
        $(this).one("click", handler2);
      }
      function handler2() {
        $(".inner-filter-result").removeClass("active-filter");
        $(this).one("click", handler1);
      }
      $(".btn-filter").one("click", handler1);

      /*event click Sidebar filter Movil*/
      $(".btn-filter-m").click(function () {
        $("body").addClass("sidebar-movil-active");
      });
      $(".close-sidebar-active").click(function () {
        $("body").removeClass("sidebar-movil-active");
      });
    }
  },
  loadPartners: function () {
    $("[name=email]").change(function () {
      var email = $(this).val();
      if (email.length) {
        custom.getPartners(email);
      }
    });
  },
  getPartners: function (email) {
    $.ajax({
      url: "/es/get-partners",
      data: { email },
      type: "POST",
      dataType: "json",
      success: function (response) {
        $("#divPartnerId").html("");
        if (response.success) {
          $("#divPartnerId").html(response.html);
        }
      },
      error: function (xhr, status) {
        Swal.fire({
          type: "error",
          title: "Oops...",
          text: "Se produjo un error, intentalo en unos minutos.",
        });
      },
    });
  },
  sidebarStickitCustom: function () {
    if ($(".sidebar-pay-block").length) {
      $(".sidebar-pay-block").stickit({
        screenMinWidth: 992,
        top: 30,
        onStick: function () {
          $("body").addClass("active-sidebar-index");
        },
        onUnstick: function () {
          $("body").removeClass("active-sidebar-index");
        },
        onEnd: function () {
          console.log("onEnd");
          $("body").addClass("active-s-fixed");
        },
        onUnend: function () {
          console.log("onUnend");
          $("body").removeClass("active-s-fixed");
        },
      });
    }
  },
  titleStiky: function () {
    if ($(".fixed-title").length) {
      $(".fixed-title").stickit({
        screenMinWidth: 992,
        top: 0,
        onStick: function () {
          $("body").addClass("active-z-index");
        },
        onUnstick: function () {
          $("body").removeClass("active-z-index");
        },
      });
    }
  },
  moreBlockAll: function () {
    $(".all-t-more .moreActive").on("click", function () {
      $(this).parent().find(".b-p").toggleClass("hide-desc");
      $(this).parent().find(".b-p1").slideToggle(0);
      if ($(this).text() == "Ver más") {
        $(this).text("Ver menos");
      } else {
        $(this).text("Ver más");
      }
    });

    $(".t-more-n .moreActive").on("click", function () {
      $(this).parent().find(".b-p1").toggleClass("t-active");
      $(this).parent().find(".b-p1").slideToggle(0);
      if ($(this).hasClass("t-active")) {
        $(this).html('Ocultar resumen <i class="fas fa-chevron-right"></i>');
      } else {
        $(this).html('Ver resumen <i class="fas fa-chevron-right"></i>');
      }
    });
  },
  moreBlock: function () {
    $(".link-moore").on("click", function () {
      $(".b-teaser").toggleClass("b-display");
      $(".b-complete").slideToggle(0);
      if ($(this).text() == "Ver más") {
        $(this).text("Ver menos");
      } else {
        $(this).text("Ver más");
      }
      var heightBloque =
        document.getElementById("all-desc-course").offsetHeight + 144;
      document
        .getElementById("bg-header-course")
        .setAttribute("style", "height: " + heightBloque + "px");
    });
  },
  sliderFunc: function () {
    if ($(".b-func-landing").length) {
      $(".slider-func").slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        fade: true,
        responsive: [
          {
            breakpoint: 992,
            settings: {
              dots: true,
            },
          },
        ],
      });

      $("a[data-slidef]").click(function (e) {
        e.preventDefault();
        $(this).addClass("active").siblings().removeClass("active");
        var slideno = $(this).data("slidef");
        $(".slider-func").slick("slickGoTo", slideno - 1);
      });
    }
  },
  ourClient: function () {
    if ($(".slider-client").length) {
      $(".slider-client").slick({
        centerMode: true,
        centerPadding: "116px",
        slidesToShow: 4,
        infinite: true,
        arrows: false,
        dots: false,
        autoplay: true,
        autoplaySpeed: 3000,
        responsive: [
          {
            breakpoint: 768,
            settings: {
              arrows: false,
              centerMode: true,
              centerPadding: "40px",
              slidesToShow: 3,
            },
          },
          {
            breakpoint: 480,
            settings: {
              arrows: false,
              centerMode: true,
              centerPadding: "40px",
              slidesToShow: 1,
            },
          },
        ],
      });
    }
  },
};
